import { render, staticRenderFns } from "./BlockIntro.vue?vue&type=template&id=a0fa8636&"
import script from "./BlockIntro.vue?vue&type=script&lang=js&"
export * from "./BlockIntro.vue?vue&type=script&lang=js&"
import style0 from "./BlockIntro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports